<template>
    <div class="qingwu">
        <div class="admin_main_block">
            <div class="admin_main_block_top">
                <div class="admin_main_block_left">
                    <div>活动消息编辑</div>
                </div>

                <div class="admin_main_block_right">
                    <div><el-button icon="el-icon-back" @click="$router.go(-1)">返回</el-button></div>
                </div>
            </div>

            <div class="admin_form_main">
                <el-form  label-width="100px" ref="info" :model="info">
                    <el-form-item label="标题" prop="F_VR_BIAOT" :rules="[{required:true,message:'标题不能为空',trigger: 'blur' }]"><el-input placeholder="请输入标题" v-model="info.F_VR_BIAOT"></el-input></el-form-item>
                    <el-form-item label="活动图片" prop="F_VR_HUODTP"><el-upload class="avatar-uploader" :action="$api.goodsClassUpload" :headers="upload_headers" :show-file-list="false" :on-success="handleAvatarSuccess" >
                        <img v-if="info.F_VR_HUODTP" :src="info.F_VR_HUODTP" class="avatar-upload">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload></el-form-item>

                        <el-form-item label="开始时间">
                            <el-date-picker format="yyyy-MM-dd HH:mm" v-model="info.adv_date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                        </el-form-item>


                    <el-form-item label="内容" class="width_auto_70">
                        <wangeditor @goods_content="goods_content" :contents="info.F_TE_NEIR"></wangeditor>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submitForm('info')">提交</el-button>
                        <el-button @click="resetForm('info')">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    import wangeditor from "@/components/seller/wangeditor.vue"
    export default {
        components: {
            wangeditor,
        },
    props: {},
    data() {
      return {
          edit_id:0,
          info:{
              F_VR_BIAOT:'',
              F_VR_HUODTP:'',
              F_VR_DIZ:'',
          },
          list:[],
          upload_headers:{},
      };
    },
    watch: {},
    computed: {},
    methods: {
        resetForm:function(e){
            this.$refs[e].resetFields();
        },
        submitForm:function(e){
            let _this = this;

            // 验证表单
            this.$refs[e].validate(function(res){
                if(res){
                    //  判断是Add 或者 Edit
                    let url = _this.$api.addHuodxx;
                    if(_this.edit_id>0){
                        url = _this.$api.editHuodxx+_this.edit_id;
                    }
                    // Http 请求
                    _this.$post(url,_this.info).then(function(res){
                        if(res.code == 200){
                            _this.$message.success("编辑成功");
                            _this.$router.go(-1);
                        }else{
                            _this.$message.error("编辑失败");
                        }
                    });
                }
            });
        },
        get_goods_class_info:function(){
            let _this = this;
            this.$get(this.$api.editHuodxx+this.edit_id).then(function(res){
                _this.info = res.data;
            })

        },
        get_goods_class_list:function(){
            let _this = this;
            this.$get(this.$api.addHuodxx).then(function(res){
                _this.list = res.data;
            })
        },
        selectChange:function(){
            this.$forceUpdate();
        },
        handleAvatarSuccess(res) {
            this.info.F_VR_HUODTP = res.data;
            this.$forceUpdate();
        },
        // 富文本编辑内容变化
        goods_content:function(data){
            this.info.F_TE_NEIR = data;
        },
    },
    created() {
        this.upload_headers.Authorization = 'Bearer '+localStorage.getItem('token'); // 要保证取到

        // 判断是否是编辑
        this.info.pid = 0;
        if(!this.$isEmpty(this.$route.params.id)){
            this.edit_id = this.$route.params.id;
        }else{
            return this.get_goods_class_list();
        }

        if(this.edit_id>0){
            this.get_goods_class_info();
        }
        
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>

</style>